module.exports = __webpack_public_path__ + "img/BIT_white09.b2152faf.jpg";